<template>
    <dashboard>
        <row>
            <panel size="col-5" class="filters">
                <h3 slot="title">Filters</h3>
                <label class="filter-item">
                    <h4>Location</h4>
                    <app-select
                        id="location"
                        v-model="location"
                        filterable
                        clearable
                        placeholder="Select">
                        <app-option
                            v-for="item in locations"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"/>
                    </app-select>
                </label>
                <label class="filter-item">
                    <h4>Date</h4>
                    <app-date-picker
                        id="date"
                        v-model="date"
                        format="MM/dd/yyyy"
                        title="The user can either key in date using format mm/dd/yyyy or use the calendar modal to select a date"/>
                </label>
            </panel>
            <panel size="col-19">
                <h2 slot="title">
                    Presence Report
                </h2>

                <app-alert>This is a downloadable report only. Please pick a location on the left and select a date. A report will be generated outlining presence in the given location over that time period.</app-alert>
                <app-alert v-if="error" type="error">{{ error }}</app-alert>
                <br >
                <app-button
                    size="large"
                    icon="icon-download"
                    @click="handleDownload">
                    Download Report
                </app-button>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import { mapState } from 'vuex'
import table from '@/mixins/table'
import download from '@/mixins/download'

import Location from '@/store/models/Location'

export default {
    name: 'page-reports-presence',
    mixins: [download, table],
    data() {
        return {
            location: null,
            date: null,
            showPicker: false,
            error: null,
            tableParamKeys: ['uuid', 'points'],
            points: 10
        }
    },
    computed: {
        ...mapState({
            report: ({ reportList }) => reportList.items,
            total: ({ reportList }) => reportList.total,
            authToken: ({ me }) => me.token
        }),
        locations() {
            return Location.query()
                .orderBy('name')
                .get()
        }
    },
    mounted() {
        this.getLocations({ page: 0, per_page: 9999 })
    },
    methods: {
        getLocations(params) {
            Location.$fetchAll(params)
        },
        handleDownload() {
            if (!this.location || !this.date) {
                this.error = 'Please select a location and a date on the left to generate a download.'
                return
            }
            this.postParameters('/api/v2/download/report/presence',
                { location: this.location, date: this.date },
                this.authToken)
        },
        navigateToStudentDetail({ student }) {
            this.$router.push({
                name: 'students.detail',
                params: { uuid: student.uuid }
            })
        }
    }
}
</script>

<style lang="stylus"></style>
